import { type ReactNode, useEffect } from 'react';
import { setAuthExpiryHandler, setSupabaseAccessToken, setSupabaseDbToken } from '@/configs/supabase';
import { useAuth } from './context';

export const SupabaseTokenSync = ({ children }: { children: ReactNode }) => {
  const { accessToken, supabaseToken, isAuthenticated, refreshSession, signOut } = useAuth();

  useEffect(() => {
    setSupabaseAccessToken(accessToken);
  }, [accessToken]);

  useEffect(() => {
    setSupabaseDbToken(supabaseToken);
  }, [supabaseToken]);

  useEffect(() => {
    if (!isAuthenticated) {
      setAuthExpiryHandler(undefined);
      return;
    }
    setAuthExpiryHandler(async () => {
      const result = await refreshSession();
      if (!result) {
        try {
          sessionStorage.setItem('savaf:returnTo', window.location.pathname + window.location.search);
        } catch {
          /* sessionStorage unavailable */
        }
        void signOut();
        return null;
      }
      return result;
    });
    return () => setAuthExpiryHandler(undefined);
  }, [isAuthenticated, refreshSession, signOut]);

  return <>{children}</>;
};
